<template>
  <div>
    
  </div>
</template>

<script>
export default {
  name: '/auth',
  data() {
    return {
      authCode: '',
    }
  },
  created() {
    this.authCode = this.$route.query.authCode
    this.login()
  },
  
  methods: {
     login() {
        let loading = this.$loading()
        this.$get(`/authDD?authCode=` + this.authCode).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res.mobile)
              let params = {
                userName: res.mobile,
              }
              let loading = this.$loading()
              this.$post(`/authsDD`, params).then(
                  res => {
                    loading.close()
                    if (res && res.errCode === 0) {
                      res.account = params.userName
                      this.$store.commit('user/setUserData', res)
                      this.$router.push({ path: '/manage' })
                    }
                  },
                  error => {
                    loading.close()
                    this.$message.error(error)
                  }
                )
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
     },
  }
}
</script>

<style lang="scss">
</style>